module.exports = __webpack_public_path__ + "img/003-elephant.4b7829e4.svg";